export default function register(){
    class RepeatInputDiv extends HTMLDivElement {
        connectedCallback() {
            this.addEventListener("change", ()=>{
                this.addNewLineIfNeeded() ;
            }) ;
            this.addNewLineIfNeeded() ;
        }

        get readonly() {
            return this.hasAttribute("readonly") ;
        }
        
        set readonly(readonly) {
            if(readonly){
                this.setAttribute('readonly', readonly);
            }else{
                this.removeAttribute('readonly');
            }
        }

        static get observedAttributes() {
            return ['readonly', "zz-bind-done"];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
                case 'readonly':
                    this.addNewLineIfNeeded();
                    break;
                case 'zz-bind-done':
                    this.addNewLineIfNeeded();
                    break;
            }
        }

        addNewLineIfNeeded(){
            let getArrayData = this.getArrayData ;
            if(!getArrayData && this.parentNode.nodeName === "#document-fragment"){
                //inside template (no occurrence yet)
                //the array is given by template himself
                //because this element is a "shadow" element inside 
                //the template
                getArrayData = this.parentNode.getArrayData ;
                // if( this.parentNode.getParentData){
                //     console.log("parent new line ?", this.parentNode.getParentData()) ;
                // }
            }
            if(!getArrayData){ return ; }

            if(this.readonly){ 
                let array = getArrayData() ;
                for(let i=0; i<array.length; i++){
                    if(array[i].__isNewLine){
                        array.splice(i, 1);
                        i--;
                    }
                }
            } else {
                let array = getArrayData() ;
                let defaultLineStr = "{}" ;
                let lastLineStr = JSON.stringify(array[array.length-1], (key, value)=>{
                    if(key === "__isProxy" || key === "__isNewLine"){
                        return undefined ;
                    }
                    return value ;
                }) ;
                if(lastLineStr !== defaultLineStr){
                    let newLine = JSON.parse(defaultLineStr) ;
                    newLine.__isNewLine = true ;
                    if(array.length>0){
                        delete array[array.length-1].__isNewLine ;
                    }
                    array.push(newLine) ;
                    // console.log("ADD NEW LINE TO ", array) ;
                }
            }
        }
    }
    
    customElements.define("z-repeat-input", RepeatInputDiv, { extends: "div" });
}